module.exports = __webpack_public_path__ + "img/xing-square-white.fc67e018.svg";